import { render, staticRenderFns } from "./set-product.vue?vue&type=template&id=1649f6d5&scoped=true&lang=pug&"
import script from "./set-product.vue?vue&type=script&lang=js&"
export * from "./set-product.vue?vue&type=script&lang=js&"
import style0 from "./set-product.vue?vue&type=style&index=0&id=1649f6d5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649f6d5",
  null
  
)

export default component.exports